import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { getRealType } from 'helpers/getRealType';

import { getAssetOptions } from 'hooks/data/useAssetData';
import { getSoureAppsOptions } from 'hooks/data/useSourceAppData';
import { getisRegistered } from 'hooks/useIsRegistered';

import { ResourceView } from 'views/ResourceView';

const searchSchema = z.object({
  id: z.string().optional(),
});

export type ResourceSearchSchema = z.infer<typeof searchSchema>;

export const Route = createFileRoute('/_auth/_buttonView/_layout/resources/_type/$type/_id/$id/')({
  component: ResourceView,
  validateSearch: (search) => {
    return searchSchema.parse(search);
  },
  beforeLoad: async ({ context, params }) => {
    const isRegistered = await getisRegistered(context.queryClient, params.id);

    if (isRegistered) {
      context.hideButtonBarButtons = ['info', 'training'];
    } else {
      context.hideButtonBarButtons = ['search'];
    }

    return context;
  },
  staticData: {
    back: {
      to: '/home/',
    },
  },

  loader: async ({ context, params }) => {
    const { queryClient } = context;

    const apps = await queryClient.ensureQueryData(getSoureAppsOptions());

    const app = apps.find((app) => {
      return app.id === params.id;
    });

    context.title = app?.nameOnDevice ?? 'Unknown';

    return {
      app,
      resources: await queryClient.ensureQueryData(
        getAssetOptions({
          type: getRealType(params.type),
          id: params.id,
        }),
      ),
    };
  },
});
